// Pure code formatting. No db, no server-only — so it can be unit-tested
// directly, shared with client code, and reused by the auth redirect helpers
// without dragging the database into the client bundle.

import { REFERRAL_CODE_MAX_LENGTH, REFERRAL_CODE_MIN_LENGTH } from "./config";

/**
 * Canonical form for anything a user typed or a URL carried.
 *
 * Aggressively lossy on purpose: someone reading a code off a friend's screen at
 * a venue will type it with spaces, dashes or the wrong case, and all of those
 * should resolve to the same code.
 */
export function normalizeReferralCode(raw: string | null | undefined): string {
  return (raw ?? "")
    .trim()
    .toUpperCase()
    .replace(/[^A-Z0-9]/g, "");
}

/** Cheap shape check before spending a database round trip. */
export function isPlausibleReferralCode(raw: string): boolean {
  const code = normalizeReferralCode(raw);
  return (
    code.length >= REFERRAL_CODE_MIN_LENGTH &&
    code.length <= REFERRAL_CODE_MAX_LENGTH
  );
}
